module.exports = __webpack_public_path__ + "static/img/yytx37.2986b7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx37.png
// module id = 815
// module chunks = 0